// extracted by mini-css-extract-plugin
export default {"section":"styles_section__kpI7W","img":"styles_img__SLTFo","heading":"styles_heading__sqf2x","para":"styles_para__LJN6G"};